import { brand, navItems, whatsappUrl } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Footer.module.css'

export function Footer() {
  const year = 2026

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brand}>
          <a href="#inicio" className={styles.logo}>
            <span className={styles.mark}>EH</span>
            <span className={styles.name}>{brand.name}</span>
          </a>
          <p className={styles.tagline}>{brand.tagline}</p>
          <div className={styles.socials}>
            <a href={brand.instagram} aria-label="Instagram" target="_blank" rel="noreferrer">
              <Icon name="instagram" size={20} />
            </a>
            <a href={brand.linkedin} aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <Icon name="linkedin" size={20} />
            </a>
            <a href={whatsappUrl} aria-label="WhatsApp" target="_blank" rel="noreferrer">
              <Icon name="whatsapp" size={20} />
            </a>
            <a href={`mailto:${brand.email}`} aria-label="Correo electrónico">
              <Icon name="mail" size={20} />
            </a>
          </div>
        </div>

        <nav className={styles.nav} aria-label="Pie de página">
          {navItems.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      <div className={`container ${styles.bottom}`}>
        <p>
          © {year} {brand.name}. Todos los derechos reservados.
        </p>
        <p className={styles.domain}>{brand.domain}</p>
      </div>
    </footer>
  )
}
